var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control-holder"},[_vm._t("default",null,{"color":_vm.color,"dark":_vm.dark})],2)}
var staticRenderFns = []

export { render, staticRenderFns }